import { render, staticRenderFns } from "./HomeV2.vue?vue&type=template&id=22df946b&scoped=true&"
import script from "./HomeV2.vue?vue&type=script&lang=js&"
export * from "./HomeV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df946b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCol,VContainer,VIcon,VRow,VSpacer,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\camha\\projects\\netcountable-app\\truple\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22df946b')) {
      api.createRecord('22df946b', component.options)
    } else {
      api.reload('22df946b', component.options)
    }
    module.hot.accept("./HomeV2.vue?vue&type=template&id=22df946b&scoped=true&", function () {
      api.rerender('22df946b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HomeV2.vue"
export default component.exports